module.exports = __webpack_public_path__ + "img/agenda.4d5cacf6.svg";